/**
 * `isMacLike()` — true on macOS, iPad, iPhone (where the Cmd key is the
 * primary modifier). Falls back to false for Windows / Linux / unknown.
 *
 * Uses `navigator.userAgentData` when available (Chromium 90+) and the
 * legacy `navigator.platform` otherwise. Both are read defensively so SSR
 * and ancient runtimes don't blow up.
 */
export function isMacLike(): boolean {
  if (typeof navigator === 'undefined') return false;

  const uaData = (navigator as { userAgentData?: { platform?: string } }).userAgentData;
  if (uaData?.platform) {
    return /mac|iphone|ipad|ipod/i.test(uaData.platform);
  }

  const platform = navigator.platform || '';
  return /mac|iphone|ipad|ipod/i.test(platform);
}

/** Display label for the primary modifier on the current platform. */
export function modifierLabel(): string {
  return isMacLike() ? '⌘' : 'Ctrl';
}

/**
 * `matchesPaletteShortcut(event)` — true when the keydown is the
 * platform-appropriate "open palette" combo (Cmd+K on macOS, Ctrl+K
 * elsewhere).
 */
export function matchesPaletteShortcut(event: KeyboardEvent): boolean {
  if (event.key.toLowerCase() !== 'k') return false;
  return isMacLike() ? event.metaKey : event.ctrlKey;
}
